// edit-reply-dialog.component.ts
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';
import { FeedService } from '../../services/feed.service';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { DocumentViewerComponent } from 'src/app/modules/dashboard/modules/my-directory/pages/document-viewer/document-viewer.component';

@Component({
  selector: 'app-edit-reply-dialog',
  templateUrl: './edit-reply-dialog.component.html',
  styleUrls: ['./edit-reply-dialog.component.scss']
})
export class EditReplyDialogComponent {
  replyForm: FormGroup;
  mention: string = '';
  reply_attachments = [...this.data.reply_attachments];
  removedAttachments: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditReplyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: ToastService,
    public feedService: FeedService,
    private mediaService: MediaService,
    private _dialog: MatDialog

  ) {

    const fullReply = data?.reply || '';
    const mentionMatch = fullReply.match(/^(@\w+)\s+(.*)/);
    this.mention = mentionMatch?.[1] || '';
    const message = mentionMatch?.[2] || fullReply;

    this.replyForm = this.fb.group({
      reply: [message, Validators.required]

    });
  }

  ngOnInit(): void {
    
  }
  

  onFileSelected(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file: File) => {
      const formData = new FormData();
      formData.append('directory', 'project');
      formData.append('file', file);
      this.mediaService.uploadMedia(formData).subscribe(response => {
        if (response && response.url) {
          this.reply_attachments.push({
            name: file.name,
            type: file.type,
            url: response.url,
          });
      }
      
      }, error => {
        console.error("Upload failed:", error);
      });
    });

    event.target.value = ''; 
  }

  removeFile(index: number) {
    const removedFile = this.reply_attachments[index];

    this.reply_attachments.splice(index, 1);

    this.removedAttachments.push(removedFile);
  }


  async submitData() {
    if (this.replyForm.invalid) {
      this.toast.openSnackBar('Please enter valid details');
      this.replyForm.markAllAsTouched();
      return;
    }

    const updatedReplyText = `${this.mention} ${this.replyForm.value.reply.trim()}`;

    let payloaddata = {
      reply_text: updatedReplyText,
      reply_attachments: this.reply_attachments,
    }
    

    try {
      const response = await this.feedService.updateNewsfeedReply(this.data.id, payloaddata);
      this.toast.openSnackBar('Reply updated successfully');
      this.dialogRef.close({
        reply_text: updatedReplyText,
        reply_attachments: this.reply_attachments
      });

    } catch (error) {
      this.toast.openSnackBar('Failed to update reply');
      console.error("Error updating reply:", error);
    }
  }

  reply(id: any, reply: any) {
    throw new Error('Method not implemented.');
  }

  closeDialog() {
    this.dialogRef.close();
  }
  cancel(): void {
    this.dialogRef.close();
  }


    viewreplyDocuments(document, index: number,): void {
   
    this._dialog.open(DocumentViewerComponent, {
      width: '70%',
      panelClass: ['custom-modal'],
      data: {
        documents: document,
        initialIndex: index
      }
    });
  }


}
